import React, { useState } from 'react';
import { motion } from 'framer-motion';
import CTA from './CTA';

const portfolioItems = [
  // Weddings
  { id: 1, category: 'weddings', image: '/img/i1.jpg', title: 'Elegant Wedding Ceremony' },
  { id: 2, category: 'weddings', image: '/img/i2.jpg', title: 'Royal Wedding Reception' },
  { id: 3, category: 'weddings', image: '/img/i4.jpg', title: 'Garden Wedding Setup' },
  { id: 4, category: 'weddings', image: '/img/i5.jpg', title: 'Traditional Wedding Decor' },
  { id: 5, category: 'weddings', image: '/img/i6.jpg', title: 'Luxury Wedding Venue' },
  { id: 6, category: 'weddings', image: '/img/i7.jpg', title: 'Destination Wedding' },
  { id: 7, category: 'weddings', image: '/img/i16.jpg', title: 'Romantic Wedding Setup' },
  { id: 8, category: 'weddings', image: '/img/i19.jpg', title: 'Classic Wedding Decor' },
  { id: 9, category: 'weddings', image: '/img/i22.jpg', title: 'Modern Wedding Style' },
  { id: 10, category: 'weddings', image: '/img/i25.jpg', title: 'Outdoor Wedding Ceremony' },
  { id: 11, category: 'weddings', image: '/img/i28.jpg', title: 'Vintage Wedding Theme' },
  { id: 12, category: 'weddings', image: '/img/i31.jpg', title: 'Luxury Wedding Reception' },
  { id: 13, category: 'weddings', image: '/img/i34.jpg', title: 'Beach Wedding Setup' },
  { id: 15, category: 'weddings', image: '/img/i40.jpg', title: 'Grand Wedding Celebration' },

  // Banquets
  { id: 18, category: 'banquets', image: '/img/i10.jpg', title: 'Grand Banquet Event' },
  { id: 19, category: 'banquets', image: '/img/i14.jpg', title: 'Elegant Banquet Dining' },
  { id: 20, category: 'banquets', image: '/img/i17.jpg', title: 'Premium Banquet Service' },
  { id: 21, category: 'banquets', image: '/img/i20.jpg', title: 'Royal Banquet Experience' },
  { id: 22, category: 'banquets', image: '/img/i23.jpg', title: 'Modern Banquet Design' },
  { id: 23, category: 'banquets', image: '/img/i26.jpg', title: 'Traditional Banquet Hall' },
  { id: 24, category: 'banquets', image: '/img/i29.jpg', title: 'Luxury Dining Experience' },
  { id: 25, category: 'banquets', image: '/img/i32.jpg', title: 'Grand Banquet Setup' },
  { id: 26, category: 'banquets', image: '/img/i35.jpg', title: 'Executive Banquet Service' },
  { id: 27, category: 'banquets', image: '/img/i38.jpg', title: 'Premium Banquet Event' },

  // Corporate
  { id: 29, category: 'corporate', image: '/img/i11.jpg', title: 'Corporate Event Setup' },
  { id: 30, category: 'corporate', image: '/img/i12.jpg', title: 'Business Conference' },
  { id: 31, category: 'corporate', image: '/img/i13.jpg', title: 'Corporate Gala' },
  { id: 34, category: 'corporate', image: '/img/i18.jpg', title: 'Executive Conference' },
  { id: 35, category: 'corporate', image: '/img/i21.jpg', title: 'Corporate Networking Event' },
  { id: 36, category: 'corporate', image: '/img/i24.jpg', title: 'Business Summit' },
  { id: 37, category: 'corporate', image: '/img/i27.jpg', title: 'Corporate Awards Ceremony' },
  { id: 38, category: 'corporate', image: '/img/i30.jpg', title: 'Professional Meeting Space' },
  { id: 39, category: 'corporate', image: '/img/i33.jpg', title: 'Corporate Training Event' },
  { id: 40, category: 'corporate', image: '/img/i36.jpg', title: 'Business Launch Event' },
  { id: 41, category: 'corporate', image: '/img/i39.jpg', title: 'Corporate Team Building' },
];

const categories = [
  { id: 'all', label: 'All Work', count: 35 },
  { id: 'weddings', label: 'Weddings', count: 14 },
  { id: 'banquets', label: 'Banquets', count: 10 },
  { id: 'corporate', label: 'Corporate', count: 11 },
];

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filteredItems = activeCategory === 'all'
    ? portfolioItems
    : portfolioItems.filter(item => item.category === activeCategory);

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative h-screen min-h-[600px] max-h-[900px] overflow-hidden pt-20 sm:pt-0">
        <img
          src="/pin7.jpg"
          alt="Creative Gallery Showcase"
          className="absolute inset-0 w-full h-full object-cover scale-105 transition-transform duration-[15s] ease-out"
        />
        <div className="absolute inset-0 bg-black/55" />

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 h-full flex items-center justify-center text-center">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="text-white/70 text-[10px] sm:text-xs tracking-[0.3em] sm:tracking-[0.4em] uppercase mb-6 sm:mb-8"
            >
              Creative Gallery
            </motion.div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-white leading-tight mb-6 sm:mb-10">
              Showcase
            </h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="text-sm sm:text-base md:text-lg text-white/90 max-w-4xl mx-auto leading-relaxed mb-8 sm:mb-12"
            >
              Explore our curated collection of memorable moments and stunning celebrations. Each image tells a story of elegance, creativity, and unforgettable experiences.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.7 }}
              className="flex items-center justify-center"
            >
              <a href="#gallery" className="group relative px-8 sm:px-12 py-4 sm:py-6 border-2 border-white/80 text-white text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.4em] uppercase bg-transparent hover:bg-white hover:text-black transition-all duration-500 rounded-sm backdrop-blur-sm">
                <span className="pointer-events-none absolute -top-5 left-1/2 -translate-x-1/2 hidden sm:flex items-center gap-4 text-white group-hover:text-black transition-colors duration-300">
                  <span className="block h-px w-16 bg-white/60 group-hover:bg-black/60 transition-colors" />
                  <span className="block w-3 h-3 rounded-full border-2 border-white/70 group-hover:border-black/70 transition-colors" />
                  <span className="block h-px w-16 bg-white/60 group-hover:bg-black/60 transition-colors" />
                </span>
                VIEW GALLERY
                <div className="absolute inset-0 bg-white/5 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </a>
            </motion.div>
          </motion.div>
        </div>

        {/* Floating decorative elements */}
        <div className="absolute bottom-10 left-10 opacity-30">
          <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
        </div>
        <div className="absolute top-20 right-20 opacity-20">
          <div className="w-1 h-1 bg-white rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
      </section>

      {/* Portfolio Gallery Section */}
      <section id="gallery" className="py-20 bg-gradient-to-br from-[#395958] via-[#2a4342] to-[#1a2f2e]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <div className="text-white/70 text-xs tracking-[0.4em] uppercase mb-4">
              Our Work
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-4">
              Portfolio Gallery
            </h2>
          </motion.div>

          {/* Category Tabs */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-wrap justify-center gap-4 mb-12"
          >
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-8 py-3 text-sm tracking-wider uppercase transition-all duration-300 rounded-sm ${activeCategory === category.id
                  ? 'bg-white text-[#395958] shadow-lg'
                  : 'bg-white/10 text-white hover:bg-white/20 border border-white/20'
                  }`}
              >
                {category.label} ({category.count})
              </button>
            ))}
          </motion.div>

          {/* Masonry Gallery */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {filteredItems.map((item, index) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-2xl bg-white/5 backdrop-blur-sm">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-80 object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                    <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
                    <p className="text-sm text-white/80 capitalize">{item.category}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <CTA />
    </div>
  );
}